import axios from 'axios';

const fetcher = axios.create();
fetcher.interceptors.request.use(req => {
  req.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  return req;
});

fetcher.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('token');

      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export default fetcher;
